export const VARIANT_LABEL_MAP = {
  functions: 'argument',
  evaluator: 'criteria',
  schema: 'property',
  nested: 'property',
};

export function requiredEntriesToRequired(
  requiredEntries: { key: string; required: boolean }[]
) {
  return requiredEntries.reduce((acc, { key, required }) => {
    if (required) {
      return [...acc, key];
    }
    return acc;
  }, [] as string[]);
}
